export const ai_platforms = [
	{ id: null, label: 'Not specified' },
	{ id: 'openai' },
	{ id: 'sonic' }
];

export const agent_modalities = [
	{ id: null, label: 'Not specified' },
	{ id: 'Text' },
	{ id: 'Voice' }
];

export const priorities = [
	{ id: 0 },
	{ id: 1 },
	{ id: 2 },
	{ id: 3 }
];
